import { z } from 'zod'

const schema = z.object({
  VITE_DASHBOARD_BACKEND_URL: z.string().url(),
  VITE_DASHBOARD_GAME_INSPECTION_WS_URL: z.string().url().optional(),
})

const parsed = schema.safeParse(import.meta.env)

if (!parsed.success) {
  /* c8 ignore next 3 */
  console.error('[env] invalid environment', parsed.error.flatten().fieldErrors)
  throw new Error('Invalid dashboard env. See console for details.')
}

export const env = parsed.data

export const config = {
  apiUrl: env.VITE_DASHBOARD_BACKEND_URL,
  wsUrl: env.VITE_DASHBOARD_GAME_INSPECTION_WS_URL,
}
